import { Card, CardContent } from "@mui/material";
import { useSelector } from "react-redux";

const CustomCard = ({
    children,
    width,
    height,
    direction,
    minWidth,
    fullWidth,
    alignItems,
    justifyContent,
    spacing,
    sx,
    pb,
    padding,
    onClick,
    pointer
}) => {
    const paletteMode = useSelector((state) => state?.userSettings?.paletteMode);
    return (
        <Card
            onClick={() => onClick ? onClick() : null}
            sx={{
                cursor: pointer ? "pointer" : "auto",
                width: width ? width : fullWidth ? '100%' : "auto",
                minWidth: minWidth ? minWidth : "auto",
                bgcolor: "bg.main",
                boxShadow: paletteMode === "dark"
                    ? "0px 0px 10px 1px #44444480"
                    : "0px 0px 10px 1px #EEEEEE80",
                borderRadius: 5,
                "& .MuiCardContent-root, & .MuiCardActions-root": {
                    border: "none",
                    "&::before, &::after": { display: "none" },
                },
                "& .MuiDivider-root": { display: "none" }, // אם יש Divider פנימי
                ...sx,
            }}>
            < CardContent
                sx={{
                    display: "flex",
                    height: height ? height : "auto",
                    flexDirection: direction ?? "column",
                    alignItems: alignItems ? alignItems : '',
                    justifyContent: justifyContent ? justifyContent : '',
                    gap: spacing ? spacing : { xs: 1.5, md: 1 },
                    padding: padding || padding === 0 ? padding : 1,
                    "&:last-child": { pb: pb ?? 1 },
                }}>
                {children}
            </CardContent >
        </Card >

    );
}
export default CustomCard;